<sdps-tooltip
  #tooltip
  [attr.sdps-id]="tooltipSdpsId"
  [attr.topic-id]="tooltipTopic"
  position="{{position}}"
  [ngClass]="marginPosition ? 'marginLeftPosition' : ''"
>
  <span slot="tooltip-content" class="tooltip-content">
    <div class="close-icon sch-thin-x" (click)="changeTooltipState()" *ngIf="containsLink"></div>
    <ng-content select="tooltip-content"></ng-content>
  </span>
  <span slot="trigger-element">
    <ng-content select="tooltip-trigger-element"></ng-content>
  </span>
</sdps-tooltip>